<template>
  <VaNavbar class="app-layout-navbar py-2 px-0">
    <template #left>
      <div class="left">
        <Transition v-if="isMobile" name="icon-fade" mode="out-in">
          <VaIcon
            color="primary"
            :name="isSidebarMinimized ? 'menu' : 'close'"
            size="24px"
            style="margin-top: 3px"
            @click="isSidebarMinimized = !isSidebarMinimized"
          />
        </Transition>
        <div class="app-brand">
          <div class="brand-logo">
            <div class="logo-container">
              <VaIcon name="traffic" size="2rem" color="primary" />
              <div class="logo-accent"></div>
            </div>
          </div>
          <div class="brand-text">
            <h1 class="brand-title">Trafik İhlali</h1>
            <p class="brand-subtitle">Yönetim Sistemi</p>
          </div>
        </div>
      </div>
    </template>
    <template #right>
      <AppNavbarActions class="app-navbar__actions" :is-mobile="isMobile" />
    </template>
  </VaNavbar>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useGlobalStore } from '../../stores/global-store'
import AppNavbarActions from './components/AppNavbarActions.vue'

defineProps({
  isMobile: { type: Boolean, default: false },
})

const GlobalStore = useGlobalStore()

const { isSidebarMinimized } = storeToRefs(GlobalStore)
</script>

<style lang="scss" scoped>
.va-navbar {
  z-index: 2;
  border-bottom: 1px solid var(--va-background-border);
  background: var(--va-background-secondary);

  @media screen and (max-width: 950px) {
    .left {
      width: 100%;
    }

    .app-navbar__actions {
      display: flex;
      justify-content: space-between;
    }
  }
}

.left {
  display: flex;
  align-items: center;
  margin-left: 1rem;

  & > * {
    margin-right: 1rem;
  }

  & > *:last-child {
    margin-right: 0;
  }
}

.app-brand {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 0;
}

.brand-logo {
  position: relative;
}

.logo-container {
  width: 48px;
  height: 48px;
  background: linear-gradient(135deg, #2e7d32 0%, #43a047 100%);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  box-shadow: 0 4px 12px rgba(46, 125, 50, 0.3);
  transition: all 0.3s ease;
}

.logo-container:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(46, 125, 50, 0.4);
}

.logo-container .va-icon {
  color: white !important;
  z-index: 2;
}

.logo-accent {
  position: absolute;
  top: -2px;
  right: -2px;
  width: 12px;
  height: 12px;
  background: linear-gradient(135deg, #f9a825 0%, #fdd835 100%);
  border-radius: 50%;
  border: 2px solid white;
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0%,
  100% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.1);
    opacity: 0.8;
  }
}

.brand-text {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.brand-title {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 700;
  color: var(--va-text-primary);
  line-height: 1.2;
  background: linear-gradient(135deg, #2e7d32 0%, #43a047 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;

  @media screen and (max-width: 768px) {
    font-size: 1.1rem;
  }
}

.brand-subtitle {
  margin: 0;
  font-size: 0.75rem;
  font-weight: 500;
  color: var(--va-text-secondary);
  line-height: 1;
  letter-spacing: 0.5px;
  text-transform: uppercase;

  @media screen and (max-width: 768px) {
    font-size: 0.7rem;
  }
}

/* Mobile responsive */
@media screen and (max-width: 640px) {
  .app-brand {
    gap: 8px;
  }

  .logo-container {
    width: 40px;
    height: 40px;
  }

  .logo-container .va-icon {
    font-size: 1.5rem !important;
  }

  .logo-accent {
    width: 10px;
    height: 10px;
  }

  .brand-title {
    font-size: 1rem;
  }

  .brand-subtitle {
    font-size: 0.65rem;
  }
}

/* Animation for brand */
.app-brand {
  animation: slideInLeft 0.6s ease-out;
}

@keyframes slideInLeft {
  from {
    opacity: 0;
    transform: translateX(-20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.icon-fade-enter-active,
.icon-fade-leave-active {
  transition: transform 0.5s ease;
}

.icon-fade-enter,
.icon-fade-leave-to {
  transform: scale(0.5);
}
</style>
